import WithRender from "../../templates/imageEditor/layerEditor.html";
import { mapGetters } from "vuex";

import LayerItem from "../imageEditor/LayerItem";

export default WithRender({
  components: {
    appLayerItem: LayerItem
  },
  props: ["type"],
  computed: {
    ...mapGetters(["getLayerItems", "getLayerItemsDefaults"]),
    items: function () {
      return this.getLayerItems(this.type);
    },
    defaultItemProps: function () {
      return this.getLayerItemsDefaults(this.type);
    }
  },
  methods: {
    updateItem(index, data) {
      this.$store.commit("updateItem", {
        type: this.type,
        index: index,
        props: data
      });
    }
  }
});
